import React from 'react';

export interface NumericCellProps {
    value: number | string | null | undefined;
    format?: 'currency' | 'percent' | 'number';
}

const NumericCell: React.FC<NumericCellProps> = ({ value, format = 'number' }) => {
    if (value == null || value === '') return null;
    const num = typeof value === 'number' ? value : parseFloat(String(value));
    if (isNaN(num)) return null;
    if (format === 'currency') {
        return <>{num.toFixed(2)}</>;
    }
    if (format === 'percent') {
        const str = String(value).replace('%', '');
        const pct = parseFloat(str);
        return <>{!isNaN(pct) ? Math.round(pct) : ''}</>;
    }
    return <>{Number(value).toFixed(format === 'number' && Number.isInteger(num) ? 0 : 2)}</>;
};

export default React.memo(NumericCell);
